import UsaLayout from "./layout/USALayout";
import ContactHeader from "./USA-Components/ContactHeader";
import InTouch from "./USA-Components/InTouch";
import ContactForm from "./USA-Components/ContactForm";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const USAContactus = () => {
    const location = useLocation();

     useEffect(() => {
    if (location.state?.scrollTo) {
        setTimeout(() => {
        document
            .getElementById(location.state.scrollTo)
            ?.scrollIntoView({ behavior: "smooth" });
        }, 100);
    }
}, [location]);
    return (
        <UsaLayout>
            <ContactHeader/>
            <InTouch/>
            <ContactForm/>
             <ToastContainer 
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </UsaLayout>
    )
}

export default USAContactus
;